var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-sheet',{attrs:{"tile":""}},[_c('v-sheet',{staticClass:"py-3",attrs:{"tile":""}},[_c('base-title',{attrs:{"align":"center","title":"RELATED PROJECTS","tag":"h2","space":"0"}})],1),_c('projects',{staticClass:"py-12 py-md-12"})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }